export enum CommandHighlightMode {
    NONE,
    SELECTED,
    EXECUTING,
}
